import { render, staticRenderFns } from "./BaseGateway.vue?vue&type=template&id=09071c90&"
import script from "./BaseGateway.vue?vue&type=script&lang=js&"
export * from "./BaseGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports